<div class="clients-created-section">
  <div class="section-header">
    <div class="section-icon">🎨</div>
    <h2>{{ 'HOME.CLIENTINFO' | translate }} <span class="highlight-text">{{'HOME.CLIENTINFO_CREATE' | translate }}</span></h2>
    <p class="section-subtitle">{{ 'HOME.CLIENTCREATIONS_SUBTITLE' | translate }}</p>
  </div>

  <div class="magnets-showcase">
    <div class="magnets-grid">
      @for (image of ['e.webp', '1.webp', '4.webp', 'g.webp', 'b.webp', '2.webp', '3.webp', 'f.webp']; track image; let i = $index) {
        <div class="magnet-item">
          <div class="magnet-card" (click)="openMagnetPopup(image)">
            <img loading="lazy" [src]="'../../assets/images/' + image" alt="Client creation">
            <div class="magnet-overlay">
            </div>
            <!-- <div class="magnet-tap-hint" *ngIf="shouldShowTapHint(i)">
            <span>👆 Tap to view</span>
          </div> -->
        </div>
      </div>
    }
  </div>
</div>
</div>


@if (showMagnetPopup) {
  <div class="magnet-popup-modal" [class.show]="!isPopupAnimating && !isPopupClosing" [class.closing]="isPopupClosing" (click)="closeMagnetPopup()">
    <div class="magnet-zoom-container">
      <div class="magnet-flip-box" [class.animate]="!isPopupAnimating">
        <div class="magnet-flip-box-inner">
          <div class="magnet-flip-box-front">
            <img [src]="selectedMagnetImage" alt="Magnet Design" />
          </div>
          <div class="magnet-flip-box-back">
            <img src="../../assets/images/text.svg" alt="Magnet Back" />
          </div>
        </div>
      </div>
    </div>
  </div>
}